<template>
    <div>
        <a-modal title="添加配置" :visible="dynaimacState.isShow" :confirm-loading="confirmLoading" @ok="handleOk"
            @cancel="handleCancel">
            <a-form-model ref="ruleForm" :model="form" layout="inline" v-on:keyup.enter="handleOk"  :rules="rules" >
                <a-form-model-item label="配置项" prop="name">
                    <a-input v-model="form.name" />
                </a-form-model-item>
                <a-form-model-item label="值">
                    <a-input-number v-model="form.value" v-on:keyup.enter="handleOk" />
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            confirmLoading: false,
            form: {
                name: '',
                value:''
            },
            rules: {
                name: [
                    { required: true, message: '请输入配置名称', trigger: 'blur' },
                    { min: 1, max: 50, message: '配置名称长度 3 ~ 50', trigger: 'blur' },
                ],
                value: [
                    { required: true, message: '请输入配置值', trigger: 'blur'},

                ]
            }

        }
    },
    props:{
        dynaimacState:{
            isShow:false,
        }
    },
    methods: {
        handleOk() {
            let that = this;
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    console.log(that.form.value)
                    if(that.form.value == null || that.form.value == ""){
                        that.message.error("值不能为空");
                    }
                    else{
                        that.$emit('onModalHide',that.form);
                        that.form.name = '';
                        that.form.value = '';
                    }

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleCancel() {
            this.$emit('onModalHide',null);

        },
    },
};
</script>
